import React from "react";
import { CheckoutFeedbackFilter } from "@/services/interfaces/IFeedbackService";
import RoomFilter from "./room";
import CreatedAtFilter from "./date";
import RatingFilter from "./rating";

export interface ReservationFeedbacksFilterProps {
  filters: Omit<
    CheckoutFeedbackFilter,
    "sortBy" | "page" | "limit" | "hotelId"
  >;
  onChange: (
    newFilters: Omit<
      CheckoutFeedbackFilter,
      "sortBy" | "page" | "limit" | "hotelId"
    >,
  ) => void;
}

const ReservationFeedbacksFilters: React.FC<
  ReservationFeedbacksFilterProps
> = ({ filters, onChange }) => {
  return (
    <div className="flex flex-wrap gap-4">
      <CreatedAtFilter
        range={{
          from: filters.feedbackStartDateRange,
          to: filters.feedbackEndDateRange,
        }}
        onChange={(range) =>
          onChange({
            ...filters,
            feedbackStartDateRange: range.from,
            feedbackEndDateRange: range.to,
          })
        }
      />

      <RatingFilter
        onChange={(rating) =>
          onChange({ ...filters, minRating: parseInt(rating) })
        }
        rating={filters.minRating?.toString() || "1"}
      />

      <RoomFilter
        onChange={(ids) => onChange({ ...filters, roomIds: ids })}
        ids={filters.roomIds || []}
      />
    </div>
  );
};

export default ReservationFeedbacksFilters;
